<template>
  <section class="hero">
    <div class="container hero__container">
      <div class="hero__image"></div>
      <div class="hero__text container--p-all">
        <h1> Next generation digital banking </h1>
        <p> Take your financial life online. Your Easybank account will be a one-stop-shop
  for spending, saving, budgeting, investing, and much more. </p>
        <button type="button" class="">Request Invite</button>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/sections/hero.scss'
</style>
